<template>
    <div>
      <ApproprationsUtils/>
    </div>
</template>

<script>
import ApproprationsUtils from '../../../components/apportionment/utils/approprationsUtils.vue';

export default {
  name: 'apportionmentUtils',
  data: () => ({

  }),
  components: {
    ApproprationsUtils,
  },
};
</script>
